import React from "react";

import CenterIcon from "../../ui/CenterIcon";

const InputIcon = ({ icon }) => {
    return <CenterIcon className="text-cyan-500" icon={icon} />;
};

export default InputIcon;
